import { PlayerRef } from '@remotion/player';
import { createContext } from 'react';

export type RemotionPlayerContextType = {
  playerRef: PlayerRef | null;
};
export const RemotionPlayerContext = createContext<RemotionPlayerContextType>({ playerRef: null });
